import { Popover } from 'antd';
import { MButton } from '@Components/Base';

import { ConfigItem } from '@Types/index';
import AppsPopoverContent from './AppsPopoverContent/AppsPopoverContent';

import Apps from '../Apps';

import styles from './apps-popover.module.css';

interface AppsPopoverProps {
  configPopoverContent: Array<ConfigItem>;
  appsText: string;
}

const AppsPopover: React.FC<AppsPopoverProps> = ({
  configPopoverContent,
  appsText,
}) => {
  return (
    <Popover
      placement="bottomLeft"
      arrow={false}
      content={<AppsPopoverContent configItems={configPopoverContent} />}
      trigger="click"
    >
      <MButton className={styles.button} type="text">
        <Apps text={appsText} />
      </MButton>
    </Popover>
  );
};

export default AppsPopover;
